export const sharedConfig = {
  tolgeeApi: 'https://app.tolgee.io',
  expertDurationMins: '50',
  orientationCallDurationMins: '20',
  defaultLocale: 'en',
  defaultTimezone: 'Europe/Berlin',
};
